import React, { useState, useContext } from "react";
import {
  Avatar,
  Box,
  Paper,
  Container,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AuthContext } from "Firebase/AuthProvider";
import { BuildingContext } from "Context/BuildingProvider";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import Page from "components/Page";
import { EditOutlined } from "@material-ui/icons";
import { GET_TASKS } from "lib/tasks";
import { GetTasksQueryResult, Task } from "generated/graphql";

export default function TasksTable() {
  const history = useHistory();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetTasksQueryResult = useQuery(GET_TASKS, {
    variables: {
      buildingId: currentBuilding?.Id,
      limit,
      offset: page,
    },
  });

  const handleEditClick = (id: string) => {};

  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };
  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.Task) {
    return (
      <React.Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Priority</TableCell>
                    <TableCell>Steps</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Updated At</TableCell>
                    <TableCell>Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.Task.slice(0, limit).map((task) => (
                    <TableRow hover key={task.Id}>
                      <TableCell component="th" scope="row">
                        {task.Name}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {task.Priority}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {task.SubTasks.length}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {task.created_at}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {task.updated_at}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            handleEditClick(task.Id);
                          }}
                        >
                          <EditOutlined />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data.Task_aggregate.aggregate?.count
                ? data.Task_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </React.Fragment>
    );
  } else {
    return <div>No Tasks</div>;
  }
}
